import MdDatepicker from "./MdDatepicker"

const MdDatepickerPlugin = {
  install(app) {
    app.component(MdDatepicker.name, MdDatepicker)
  },
}

export default MdDatepickerPlugin
